// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Button, Row, Modal } from 'react-bootstrap'
import braintree from 'braintree-web'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import { ModuleItem } from '../components/moduleItem'
import { Loading } from '../components/loading'
import config from '../config/config.json'
import { fixScrollbar, getCategoriesString, getCategoriesOrgs } from '../utils/enUtils.js'

export class Store extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            modules: [],
            tutorialModules: [],
            foundationalModules: [],
            showPurchaseModal: false,
            showPurchaseFreeModal: false,
            paymentMethodButtonVisibility: { display: 'block' },
            confirmPaymentButtonVisibility: { display: 'none' },
            purchaseModuleName: "",
            purchaseModuleId: "",
            purchaseModulePrice: 0,
            purchaseModuleQuantity: 1,
            paymentForm: { display: 'block' },
            paymentSuccessful: { display: 'none' }
        }

        this.path = {
            modules: '/assets/images/Modules/'
        }

        this.clientToken = {
            'staging': 'sandbox_rbgc9495_3tg6fjhbsnv6k26j',
            'production': 'production_kzkyg36z_vbpj52gm2fdwfdgb'
        }

        this.getAllModules(this.props.env, config)
        this.init()

        this.buyModule = this.buyModule.bind(this)
        this.buyFreeModule = this.buyFreeModule.bind(this)
        this.prepareModuleItems = this.prepareModuleItems.bind(this)
        this.openPurchaseModal = this.openPurchaseModal.bind(this)
        this.closePurchaseModal = this.closePurchaseModal.bind(this)
        this.purchaseModal = this.purchaseModal.bind(this)
        this.braintreeInit = this.braintreeInit.bind(this)
        this.handlePaymentSelectionButtonClick = this.handlePaymentSelectionButtonClick.bind(this)
        this.updateQuantity = this.updateQuantity.bind(this)
        this.openPurchaseFreeModal = this.openPurchaseFreeModal.bind(this)
        this.closePurchaseFreeModal = this.closePurchaseFreeModal.bind(this)
        this.purchaseFreeModal = this.purchaseFreeModal.bind(this)
        this.handleBuyFreeModule = this.handleBuyFreeModule.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
    }

    getAllModules(env, config) {
        fetch(config[env] + config.api.all_modules.endpoint, {
            method: config.api.all_modules.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                // Filter out modules with no category
                let modules = responseJson.filter(module => {
                    return module.category !== null
                })

                modules.sort((a, b) => (a.name < b.name) ? -1 : 1)
                modules = this.getRelevantModules(modules, this.props.appData.company)

                let tutorialModules = modules.filter(module => {
                    return module.category.includes(config.consts.MOD_TUTORIAL)
                })

                let foundationalModules = modules.filter(module => {
                    return module.category.includes(config.consts.MOD_FOUNDATION)
                })

                this.setState({
                    modules,
                    tutorialModules,
                    foundationalModules,
                    loading: false
                })

            })
            .catch((error) => {
                console.error(error)
            })
    }

    getRelevantModules(modules, myName) {
        return modules.filter(module => {
            if (module.category.includes(config.consts.MOD_EXCLUSIVE)) {
                let orgNamesArr = getCategoriesOrgs(module.category)
                module.category = getCategoriesString(module.category)

                return orgNamesArr && orgNamesArr.includes(myName)
            }
            else {
                return true
            }
        })
    }

    handleBuyFreeModule(e) {
        e.preventDefault()

        this.buyFreeModule(this.props.env, config)
    }

    buyFreeModule(env, config) {
        fetch(config[env] + config.api.create_licence.endpoint, {
            method: config.api.create_licence.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken
            },
            body: JSON.stringify({
                licence: {
                    enabler_module_id: this.state.purchaseModuleId,
                    user_nonce: null,
                    count: this.state.purchaseModuleQuantity
                }
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    paymentForm: { display: 'none' },
                    paymentSuccessful: { display: 'block' }
                })

            })
            .catch((error) => {
                console.error(error)
            })
    }

    buyModule(env, config, instance) {
        fetch(config[env] + config.api.create_licence.endpoint, {
            method: config.api.create_licence.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken
            },
            body: JSON.stringify({
                licence: {
                    enabler_module_id: this.state.purchaseModuleId,
                    user_nonce: instance.nonce,
                    count: this.state.purchaseModuleQuantity
                }
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    paymentForm: { display: 'none' },
                    paymentSuccessful: { display: 'block' }
                })

            })
            .catch((error) => {
                console.error(error)
            })
    }

    evalFreeModule(modulePrice) {
        return (Number(modulePrice) === 0)
    }

    prepareModuleCategories() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        else {
            return (
                <div>
                    <section className="tutorial-modules">
                        <h3 className="category-title">Tutorials</h3>
                        {this.prepareTutorialModuleItems()}
                    </section>

                    <section className="foundation-modules">
                        <h3 className="category-title">Foundation Topics</h3>
                        {this.prepareFoundationalModuleItems()}
                    </section>
                </div>
            )
        }
    }

    prepareModuleItems() {
        return this.state.modules.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    category={module.category}
                    summary={module.summary}
                >
                    <Row>
                        <Col md={8} sm={6}>
                            Price: <span>${Number(module.price).toFixed(2)}</span>
                        </Col>
                        <Col md={4} sm={6}>
                            <Button data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseModal}>Buy</Button>
                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }

    prepareTutorialModuleItems() {
        return this.state.tutorialModules.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    category={module.category}
                    summary={module.summary}
                >
                    <Row>
                        <Col md={8} sm={6}>
                            <p><span><b>Price: </b></span> {this.evalFreeModule(module.price) ? "Free" : "$" + Number(module.price).toFixed(2)}</p>
                        </Col>
                        <Col md={4} sm={6}>
                            <Button bsStyle="primary" data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseFreeModal}>Add Module</Button>
                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }

    prepareFoundationalModuleItems() {
        return this.state.foundationalModules.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    category={module.category}
                    summary={module.summary}
                >
                    <Row>
                        <Col md={8} sm={6}>
                            <p><span><b>Price: </b></span> {this.evalFreeModule(module.price) ? "Free" : "$" + Number(module.price).toFixed(2)} </p>
                        </Col>
                        <Col md={4} sm={6}>
                            {
                                this.evalFreeModule(module.price) ?
                                    (<Button data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseFreeModal} bsStyle="primary">Add Module</Button>) :
                                    (<Button data-index={index} data-moduleName={module.name} data-moduleId={module.id} data-modulePrice={module.price} onClick={this.openPurchaseModal} bsStyle="primary">Buy</Button>)
                            }
                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }


    openPurchaseModal(e) {
        this.setState({
            showPurchaseModal: true,
            paymentForm: { display: 'block' },
            purchaseModuleName: e.target.getAttribute('data-moduleName'),
            purchaseModuleId: e.target.getAttribute('data-moduleId'),
            purchaseModulePrice: Number(e.target.getAttribute('data-modulePrice')).toFixed(2)
        })
    }

    closePurchaseModal() {
        this.setState({
            showPurchaseModal: false,
            confirmPaymentButtonVisibility: { display: 'none' },
            paymentMethodButtonVisibility: { display: 'block' },
            paymentForm: { display: 'block' },
            paymentSuccessful: { display: 'none' }
        })

        fixScrollbar()
    }

    openPurchaseFreeModal(e) {
        this.setState({
            showPurchaseFreeModal: true,
            paymentForm: { display: 'block' },
            purchaseModuleName: e.target.getAttribute('data-moduleName'),
            purchaseModuleId: e.target.getAttribute('data-moduleId'),
            purchaseModulePrice: Number(e.target.getAttribute('data-modulePrice')).toFixed(2)
        })
    }

    closePurchaseFreeModal() {
        this.setState({
            showPurchaseFreeModal: false,
            confirmPaymentButtonVisibility: { display: 'none' },
            paymentMethodButtonVisibility: { display: 'block' },
            paymentSuccessful: { display: 'none' }
        })

        fixScrollbar()
    }

    purchaseFreeModal() {
        return (
            <Modal show={this.state.showPurchaseFreeModal} onHide={this.closePurchaseFreeModal} onExited={this.closePurchaseFreeModal} bsSize='small'>
                <Modal.Header closeButton>
                    <Modal.Title componentClass="h4">Add Module</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form id="payment-form" method="post" style={this.state.paymentForm}>
                        <div>
                            <label>Module: </label>{this.state.purchaseModuleName}
                        </div>
                        <div>
                            <label>Quantity: </label>
                            <input type="number" id="modulePurchaseQuantity" onChange={this.updateQuantity} defaultValue={1} />
                        </div>
                        <div><label>Unit Price (incl. GST): </label>Free</div>
                        <Button bsStyle="primary" type="submit" id="select-payment-button" style={this.state.paymentMethodButtonVisibility} onClick={this.handleBuyFreeModule}>Confirm</Button>
                    </form>

                    <section className="payment-successful" style={this.state.paymentSuccessful}>
                        <h3>Module added successfully!</h3>
                        <div><img src="/assets/images/Icons/check.png" alt="Payment Successful" /></div>
                        <Button bsStyle="primary" onClick={this.closePurchaseFreeModal}>Done</Button>
                    </section>
                </Modal.Body>
            </Modal>
        )
    }

    purchaseModal() {
        let totalPrice = this.state.purchaseModulePrice * this.state.purchaseModuleQuantity

        return (
            <Modal show={this.state.showPurchaseModal} onHide={this.closePurchaseModal} onExited={this.closePurchaseModal} bsSize='small'>
                <Modal.Header closeButton>
                    <Modal.Title componentClass="h4">Buy Module</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form id="payment-form" method="post" style={this.state.paymentForm}>
                        <div>
                            <label>Module: </label>{this.state.purchaseModuleName}
                        </div>
                        <div>
                            <label>Quantity: </label>
                            <input type="number" id="modulePurchaseQuantity" onChange={this.updateQuantity} defaultValue={1} />
                        </div>
                        <div><label>Unit Price (incl. GST): </label>${this.state.purchaseModulePrice}</div>
                        <div><label>Total Price (incl. GST): </label>${Number(totalPrice).toFixed(2)}</div>
                        <div><label>Warning: </label>This amount will be charged to your account. Any exclusive discounts will be applied to your invoice.</div>
                        <Button bsStyle="primary" type="submit" id="select-payment-button" style={this.state.paymentMethodButtonVisibility} onClick={this.handleBuyFreeModule}>I agree</Button>
                        {/*
							<Button bsStyle="primary" id="select-payment-button" style={this.state.paymentMethodButtonVisibility} onClick={this.handlePaymentSelectionButtonClick}>Select Payment Method</Button>

							<section className="drop-in-section" style={this.state.confirmPaymentButtonVisibility}>
								<div id="dropin-container"></div>
								
								<Button bsStyle="primary" type="submit" id="submit-button" >Confirm Payment</Button>
							</section>
						*/}
                    </form>

                    <section className="payment-successful" style={this.state.paymentSuccessful}>
                        <h3>Module added successfully!</h3>
                        {/*
							<h3>Payment Successful!</h3>
						*/}
                        <div><img src="/assets/images/Icons/check.png" alt="Payment Successful" /></div>
                        <Button bsStyle="primary" onClick={this.closePurchaseModal}>Done</Button>
                    </section>
                </Modal.Body>
            </Modal>
        )
    }

    updateQuantity(e) {
        if (e.target.value < 0) {
            e.target.value = Math.abs(e.target.value)
        }
        if (e.target.value - Math.floor(e.target.value) > 0) {
            e.target.value = Math.floor(e.target.value)
        }
        this.setState({
            purchaseModuleQuantity: e.target.value
        })
    }

    handlePaymentSelectionButtonClick(e) {
        this.braintreeInit()

        this.setState({
            confirmPaymentButtonVisibility: { display: 'block' },
            paymentMethodButtonVisibility: { display: 'none' },
        })
    }

    braintreeInit() {
        braintree.setup(
            this.clientToken[this.props.env],
            'dropin',
            {
                container: 'dropin-container',
                onPaymentMethodReceived: function (instance) {
                    console.log(instance)
                    this.buyModule(this.props.env, config, instance)
                }.bind(this)
            }
        )
    }

    render() {
        return (
            <div className="store-container training-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={2}
                    appData={this.props.appData}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"provider_content"}
                    profile={1}

                />

                <div className="main-body">
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                <h2 className="title">Store</h2>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            {this.prepareModuleCategories()}
                            {this.purchaseModal()}
                            {this.purchaseFreeModal()}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/store.js